import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';


Snappy.Component.SofaToSeat = class SofaToSeat extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-sofa-to-seat';
    }

    constructor(element) {
        super(element);
    }

    setVars() {
        this.$showDirectionsBtn = this.$element.find('.directions__button')[0];
        this.$panel = this.$element.find('.content__panel');
        this.$panelClose = this.$element.find('.panel__controls-button')[0];
        this.$innerPanel = this.$element.find('.panel__right');
        this.$mapInput = this.$element.find('.origin__input')[0];
    }

    addEventListeners() {
        this.$showDirectionsBtn.addEventListener('click', this.toggleDirections.bind(this));
        this.$panelClose.addEventListener('click', this.togglePanel.bind(this));
        this.$mapInput.addEventListener('focus', this.moveAutoComplete.bind(this));
    }

    moveAutoComplete (event) {
        const pacContainer = $('.pac-container');
        $(event.target).parent().append(pacContainer);
    }

    toggleDirections(event) {
        const $this = event.target;
        this.$panel.toggleClass('transition-in');

        if (this.$panel.hasClass('transition-in')) {
            console.log($($this).find('span').text('Hide Directions'));
        } else {
            console.log($($this).find('span').text('Show Directions'));
        }
    }

    togglePanel(event) {
        this.$innerPanel.toggleClass('transition-in');
        $(event.target).toggleClass('panel__controls-button--opened');
    }

    render() {
        this.setVars();
        this.addEventListeners();
        
    }
}



// WEBPACK FOOTER //
// ./components/ws-sofa-to-seat/scripts/sofa-to-seat.js